import { z } from "zod";
export const connectionTypeSchema = z.enum(["in_person", "call", "video", "message"]);
export const CONNECTION_TYPE_LABELS = {
    in_person: "In person",
    call: "Call",
    video: "Video",
    message: "Message",
};
export const connectionWhoSchema = z.enum(["family", "friend", "coworker", "community"]);
export const CONNECTION_WHO_LABELS = {
    family: "Family",
    friend: "Friend",
    coworker: "Coworker",
    community: "Community",
};
//# sourceMappingURL=connection-log.js.map